import Index from "./Index.vue";
import Show from "./Show.vue";

export default [
  {
    path: "",
    name: "UsersNewsUserNewsIndex",
    component: Index,
    meta: {
      title: "お知らせ",
      subtitle: "NEWS",
      tree: [],
    },
  },
  {
    path: ":id",
    name: "UsersNewsUserNewsShow",
    component: Show,
    meta: {
      title: "詳細",
      tree: [
        {
          title: "お知らせ",
          name: "UsersNewsUserNewsIndex",
        },
      ],
    },
  },
];
